import * as React from 'react';
import { connect } from 'react-redux';
import { getUserDetails, saveUserDetails, unmountEditUser } from 'src/actions/action.user';
import { getCurrentUrl } from 'src/effects/api/base.service';
import UserDetailsComponent from './UserDetailsComponent';
import { ApplicationMain } from 'src/styles/common';
import { Grid, Typography, Button, IconButton, FormControl, Select, Input, MenuItem } from '@material-ui/core';
import IconBackButton from '@material-ui/icons/KeyboardBackspace';
import { push } from 'connected-react-router';
import { ModuleEnum } from 'src/constants/Enum/ModuleEnum';
import { EditUserWrapper } from 'src/styles/edituser';
import DropdownMenuComponent from '../common/menu/DropdownMenuComponent';
import RestoreIcon from '@material-ui/icons/Restore';
import AddCircleIcon from '@material-ui/icons/AddCircleOutline';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';
import CancelIcon from '@material-ui/icons/CancelOutlined';
import * as PropTypes from 'prop-types';
import UserModuleListComponent from './UserModuleListComponent';
import LoaderComponent from '../common/loader.component';
import { toast } from 'react-toastify';
import { ASSIGN_COUNTRY_ERROR, TOSTAR_POSITION } from 'src/constants/NotificationMessageConstant';
import * as Crypto from 'crypto-js';
import { ALLOWED_MULTISELECT_ROLE_IDS, DATA_SECRET } from './../../constants/constants';
import { UserType } from '../../constants/Enum/UserType';

const items = [
    {
        text: 'Reset Modules',
        icon: <RestoreIcon />,
        customCss: ''
    },
    {
        text: 'Delete',
        icon: <RemoveCircleIcon />,
        customCss: 'popperDropdownDangerMenuItem'
    }
]

class EditUserComponent extends React.Component<any, any> {
    static contextTypes = {
        router: PropTypes.object
    }

    constructor(props: any) {
        super(props);
        this.state = {
            isCountryAdded: false,
            editUser: {},
            selectedCountry: 0,
            currentUserCountryModel: {},
            isAssignCountryVisible: false,
            moduleCountryAssignments: [],
            modules: [],
            isRegionValid: true,
            isOrganizationValid: true,
            isMultipleRegions: true
        }

        this.handleCountryChange = this.handleCountryChange.bind(this);
        this.updateUserDetails = this.updateUserDetails.bind(this);
        this.navigateToModuleTab = this.navigateToModuleTab.bind(this);
        this.handleAddTabChange = this.handleAddTabChange.bind(this);
        this.handleAddAssignCountryChange = this.handleAddAssignCountryChange.bind(this);
        this.updateCurrentCountryModule = this.updateCurrentCountryModule.bind(this);
        this.assignUnassignModel = this.assignUnassignModel.bind(this);
        this.gotoListing = this.gotoListing.bind(this);
        this.handleMenuItem = this.handleMenuItem.bind(this);
        this.saveUserDetails = this.saveUserDetails.bind(this);
        this.closeOnCancel = this.closeOnCancel.bind(this);
    }

    componentDidMount() {
        getCurrentUrl().then((currUrl: any) => {
            const splitUrl = currUrl.split("edituser/");
            const encryptedUserId = splitUrl[splitUrl.length - 1]
            const decryptedUserId = Crypto.AES.decrypt(encryptedUserId, DATA_SECRET);
            let editUserId;
            if (decryptedUserId) {
                const stringUserId = decryptedUserId.toString(Crypto.enc.Utf8)
                if (stringUserId) {
                    editUserId = JSON.parse(stringUserId);
                }
                else {
                    editUserId = null;
                }
            }
            else {
                editUserId = null;
            }
            this.props.getUserDetails(editUserId);
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps: any) {
        if (nextProps && nextProps.editedUser) {
            this.setState({ editUser: nextProps.editedUser, modules: nextProps.editedUser.modules });
            if (nextProps.editedUser.moduleCountryAssignments && nextProps.editedUser.moduleCountryAssignments.length > 0) {
                if (nextProps.editedUser.moduleCountryAssignments) {
                    const moduleCountryAssignments: any = [];
                    nextProps.editedUser.moduleCountryAssignments.forEach((element: any) => {
                        let moduleList: any = [];
                        const moduleListString = JSON.stringify(nextProps.editedUser.modules);
                        moduleList = JSON.parse(moduleListString);
                        const currentUserCountryModel = {
                            countryId: element.countryId,
                            countryName: element.countryName,
                            moduleIds: element.moduleIds,
                            modules: moduleList
                        };
                        moduleCountryAssignments.push(currentUserCountryModel)
                        this.updateCurrentCountryModule(currentUserCountryModel);
                    });

                    this.setState({
                        currentUserCountryModel: moduleCountryAssignments.length > 0 ? moduleCountryAssignments[0] : {},
                        moduleCountryAssignments,
                    });
                }
            }
        }
    }

    handleCountryChange = (event: any) => {
        this.setState({ selectedCountry: event.target.value });
    };

    handleAddTabChange = () => {
        this.setState({ isAssignCountryVisible: !this.state.isAssignCountryVisible });
    };

    closeOnCancel = () => {
        this.handleAddTabChange();
        this.setState({ isCountryAdded: false });
    };

    handleAddAssignCountryChange = (event: any) => {
        let moduleList: any = [];
        const moduleListString = JSON.stringify(this.props.editedUser.modules);
        moduleList = JSON.parse(moduleListString);

        const moduleIds: any = []; moduleIds.push(ModuleEnum.IntroToDataCollection);

        let filteredCountry: any = [];
        filteredCountry = this.state.editUser.countries.filter((item: any) => (item.id === this.state.selectedCountry));

        if (filteredCountry.length > 0 && filteredCountry[0]) {
            const newObj =
            {
                countryId: filteredCountry[0].id,
                countryName: filteredCountry[0].name,
                moduleIds,
                modules: moduleList
            }
            const moduleCountryAssignments: any = this.state.moduleCountryAssignments;
            // check if country is added or not 
            const isCountryAdded: any = moduleCountryAssignments.filter((item: any) => (item.countryId === filteredCountry[0].id));

            if (!(isCountryAdded.length > 0 && isCountryAdded[0])) {
                newObj.modules.forEach((model: any) => {
                    if (model.id !== ModuleEnum.IntroToDataCollection) {
                        newObj.moduleIds.push(model.id)
                    }
                });
                moduleCountryAssignments[moduleCountryAssignments.length] = newObj;
                this.updateCurrentCountryModule(newObj);

                this.setState({
                    isCountryAdded: false,
                    moduleCountryAssignments,
                    selectedCountry: 0,
                    isAssignCountryVisible: !this.state.isAssignCountryVisible
                });
            }
            else {
                this.setState({ isCountryAdded: true });
            }
        }
    };

    navigateToModuleTab = (userCountryModule: any) => {
        this.assignUnassignModel(userCountryModule);
    };

    updateUserDetails = (updatedUser: any) => {
        this.setState({
            editUser: updatedUser,
            isRegionValid: ALLOWED_MULTISELECT_ROLE_IDS.includes(updatedUser.roleId) && updatedUser.regionIds !== undefined && updatedUser.regionIds.length > 0 ? true : this.state.isRegionValid,
            isMultipleRegions: (this.props.userId === 2 && ALLOWED_MULTISELECT_ROLE_IDS.includes(updatedUser.roleId) && updatedUser.regionIds && updatedUser.regionIds.length === 1 ? true : this.state.isMultipleRegions),
            isOrganizationValid: updatedUser.organization || updatedUser.organization === '' ? true : this.state.isOrganizationValid 
        });
    };

    gotoListing = (event: any) => {
        this.props.redirectTo('/users');
    };

    updateCurrentCountryModule(currentUserCountryModel: any) {
        if (currentUserCountryModel.modules.length > 0) {
            currentUserCountryModel.modules.forEach((model: any) => {
                model.isChecked = model.id === ModuleEnum.IntroToDataCollection
                if (currentUserCountryModel.moduleIds && currentUserCountryModel.moduleIds.length > 0) {
                    const isPresent = currentUserCountryModel.moduleIds.filter((item: any) => (item === model.id));
                    if (isPresent.length > 0) {
                        model.isChecked = !model.isChecked;
                    }
                }
            });
        }
        this.setState({ currentUserCountryModel });
    }

    assignUnassignModel(currentUserCountryModel: any) {
        let updatedCurrentUserCountryModel: any = {};
        const moduleCountryAssignments = this.state.moduleCountryAssignments;
        moduleCountryAssignments.forEach((element: any) => {
            if (element.countryId === currentUserCountryModel.countryId) {
                element = currentUserCountryModel;
                updatedCurrentUserCountryModel = currentUserCountryModel;
            }
        });
        this.setState({ currentUserCountryModel: {}, moduleCountryAssignments: [] }, () => { this.setState({ currentUserCountryModel: updatedCurrentUserCountryModel, moduleCountryAssignments }) });
    }

    handleMenuItem = (option: any, action: any) => {
        if (option === 'Reset Modules') {
            let moduleList: any = [];
            const moduleListString = JSON.stringify(this.props.editedUser.modules);
            moduleList = JSON.parse(moduleListString);
            const moduleIds: any = []; moduleIds.push(ModuleEnum.IntroToDataCollection);

            action.moduleIds = moduleIds;
            action.modules = moduleList;
            this.updateCurrentCountryModule(action);
        }
        if (option === 'Delete') {
            if (this.state.moduleCountryAssignments) {
                const arrcurrentUserCountryModel: any = [];
                this.state.moduleCountryAssignments.map((element: any, index: any) => {
                    if (element.countryId !== action.countryId) {
                        arrcurrentUserCountryModel.push(element);
                    }
                })
                this.setState({
                    moduleCountryAssignments: arrcurrentUserCountryModel,
                    currentUserCountryModel: arrcurrentUserCountryModel.length > 0 ? arrcurrentUserCountryModel[0] : {}
                });
            }
        }
    }

    saveUserDetails() {
        const updatedUserDetails: any = this.state.editUser;
        if (!this.state.editUser.organization || this.state.editUser.organization === '') {
            this.setState({ isOrganizationValid: false });
            return;
        }

        if (updatedUserDetails.isQuestionReviewRequired == null && updatedUserDetails.roleId === UserType.RegionalAdmin) {
            updatedUserDetails.isQuestionReviewRequired = true
        }

        if (updatedUserDetails.roleId === 3) {
            if (this.state.moduleCountryAssignments.length === 0) {
                toast.error(ASSIGN_COUNTRY_ERROR, { position: TOSTAR_POSITION });
                return null;

            }
            else {
                updatedUserDetails.moduleCountryAssignments = this.state.moduleCountryAssignments;
            }
        }

        if ((ALLOWED_MULTISELECT_ROLE_IDS.includes(updatedUserDetails.roleId) && updatedUserDetails.regionIds === undefined) ||
            (ALLOWED_MULTISELECT_ROLE_IDS.includes(updatedUserDetails.roleId) && updatedUserDetails.regionIds && updatedUserDetails.regionIds.length === 0)) {
            this.setState({ isRegionValid: false });
            return null;
        }

        if (this.props.userId === 2 && ALLOWED_MULTISELECT_ROLE_IDS.includes(updatedUserDetails.roleId) && updatedUserDetails.regionIds && updatedUserDetails.regionIds.length > 1) {
            this.setState({ isMultipleRegions: false });
            return null;
        }

        return this.props.saveUserDetails(updatedUserDetails);
    }

    componentWillUnmount() {
        this.props.unmountEditUser(null);
    }

    render() {
        let updatedItems: any = [];
        updatedItems = items;

        return (
            <ApplicationMain>
                <LoaderComponent sending={this.props.show} />
                <EditUserWrapper>
                    <div className="pageContainer surveyScreen">
                        <div className="pageHeading">
                            <Grid container={true} spacing={8}>
                                <Grid item={true} xs={6}>
                                    <div className="pageHeadingTitle">
                                        <Typography component="h2" variant="title" align="left" gutterBottom={true} className="pageTitle">
                                            <IconButton onClick={this.gotoListing} className="backButton" color="inherit" aria-label="Open drawer">
                                                <IconBackButton />
                                            </IconButton>
                                            {this.state.editUser.firstName} {this.state.editUser.lastName}
                                        </Typography>
                                    </div>
                                </Grid>
                                <Grid item={true} xs={6}>
                                    <div className="text-right">
                                        <Button type="button" className="btn-blue" variant="outlined" size="medium" onClick={this.saveUserDetails}>
                                            Update User
                                    </Button>
                                    </div>
                                </Grid>
                            </Grid>
                        </div> <div className="pageContent">
                            <Grid container={true} spacing={24}>
                                <Grid item={true} xs={12}>
                                    <div className="contentSection">
                                        {
                                            this.state.editUser && this.state.editUser.roles &&
                                            <UserDetailsComponent
                                                updateUserDetails={this.updateUserDetails}
                                                editUser={this.state.editUser}
                                                isRegionValid={this.state.isRegionValid}
                                                isOrganizationValid={this.state.isOrganizationValid}
                                                userId={this.props.userId}
                                                isMultipleRegions={this.state.isMultipleRegions}
                                            />
                                        }
                                        {
                                            this.state.editUser.roleId === 3 &&
                                            <div className="pageTabSection">
                                                <div className="tabHeading">
                                                    <h3>Module Assignment For</h3>
                                                    {this.state.isCountryAdded && <span className="errorMessage">Selected country has been already added.</span>}
                                                </div>
                                                <div className="tab">
                                                    {this.state.moduleCountryAssignments && this.state.moduleCountryAssignments.map((element: any, index: any) => {
                                                        const isSelected = Object.keys(this.state.currentUserCountryModel).length > 0 &&
                                                            this.state.currentUserCountryModel.countryId === element.countryId;
                                                        return <div key={index} className="tabButton">
                                                            <Button type="button" className={"btn-blue btn-tab" +
                                                                (isSelected ? " tabSelected" : "")

                                                            } onClick={this.navigateToModuleTab.bind(this, element)} variant="outlined" size="medium">{element.countryName}
                                                            </Button>
                                                            <DropdownMenuComponent className={(isSelected ? " svgColor" : "")} menuItems={updatedItems} action={element} onMenuItemClicked={this.handleMenuItem} />
                                                        </div>
                                                    })}


                                                    {!this.state.isAssignCountryVisible && <Button type="button" className="btn-blue btn-tab btn-addtab" variant="outlined" size="medium" onClick={this.handleAddTabChange}>
                                                        <AddCircleIcon />
                                                    </Button>}

                                                    {this.state.isAssignCountryVisible &&
                                                        <>
                                                            <FormControl fullWidth={false} className="selectCountryTab">
                                                                <Select
                                                                    value={this.state.selectedCountry && this.state.selectedCountry}
                                                                    onChange={this.handleCountryChange}
                                                                    input={<Input name="CountryName" id="age-auto-width" />}
                                                                    autoWidth={true}
                                                                    className="countrySelection">
                                                                    <MenuItem key={0} value={0}>Select Country</MenuItem>
                                                                    {
                                                                        this.state.editUser.countries &&
                                                                        this.state.editUser.countries.map((mt: any, index: any) => {
                                                                            return <MenuItem key={index} name={mt.name} value={mt.id}>{mt.name}</MenuItem>
                                                                        })
                                                                    }
                                                                </Select>

                                                                <Button type="button" className="btn-blue" variant="outlined" size="medium" onClick={this.handleAddAssignCountryChange}>
                                                                    Assign Country</Button>

                                                                <IconButton className="cancelButton" color="inherit" onClick={this.closeOnCancel}>
                                                                    <CancelIcon className="cancelButton" />
                                                                </IconButton>

                                                            </FormControl>
                                                        </>
                                                    }
                                                </div>
                                                <div className="tabContent">
                                                    {Object.keys(this.state.currentUserCountryModel).length > 0 &&
                                                        <UserModuleListComponent assignUnassignModel={this.assignUnassignModel} currentUserCountryModel={this.state.currentUserCountryModel} />}
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                    </div>
                </EditUserWrapper>
            </ApplicationMain>
        )
    }
}

const mapStateToProps = (state: any) => {
    return {
        show: state.common.show,
        editedUser: state.user.editedUser
    };
};

const mapDispatchToProps = (dispatch: any) => {
    return {
        getUserDetails: (data: any) => dispatch(getUserDetails(data)),
        saveUserDetails: (data: any) => dispatch(saveUserDetails(data)),
        redirectTo: (path: string) => dispatch(push(path)),
        unmountEditUser: (data: string) => dispatch(unmountEditUser(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EditUserComponent);





// WEBPACK FOOTER //
// ./src/components/users/EditUserComponent.tsx